import React, { lazy } from 'react';

const InsuranceOptionsComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "carvana-purchase-insurance-options" */ '|/app/purchase/checkout/steps/insurance-options'
    )
);

export const InsuranceOptionsRoute = () => {
  return <InsuranceOptionsComponent />;
};
